import styled from 'styled-components'

export const PaginationWrapDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 21px 33px;
  & div {
    margin-right: 11px;
  }
  & div:last-child {
    margin: 0px;
  }
`;
export const NumDiv = styled.div`
  height: 37px;
  width: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => (props.active === true ? '#1E2228' : '#939599')};
  cursor: pointer;
  font-size: 12px;
  font-weight: normal;
  border-radius: 6px;
  border: 1px solid #ECECEC;
  background-color: #ffffff;
  &:hover {
    background-color: #ECECEC;
  }
`;
export const ChangeDiv = styled.div`
  height: 37px;
  width: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 6px;
  border: 1px solid #ECECEC;
  position: relative;
  background-color: #ffffff;
  &:hover {
    background-color: #ECECEC;
  }
  &:before {
    content: '';
    height: 5px;
    width: 5px;
    position: absolute;
    border-left: 1px solid #939599;
    border-bottom: 1px solid #939599;
    transform: ${props => (props.id === 'next' || props.id === 'last' ? 'rotate(-135deg)' : 'rotate(45deg)')};
  }
  &:after {
    content: '';
    height: 5px;
    width: 5px;
    position: absolute;
    border-left: 1px solid #939599;
    border-bottom: 1px solid #939599;
    display: ${props => (props.id === 'first' || props.id === 'last' ? 'block' : 'none')};
    ${props => (props.id === 'next' || props.id === 'last' ? 'margin-right: 10px;' : 'margin-left: 10px;')}
    transform: ${props => (props.id === 'next' || props.id === 'last' ? 'rotate(-135deg)' : 'rotate(45deg)')};
  }
`;
